/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileIllustratorLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileIllustratorLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m34.68 34.216.168-.936.168.936 2.352 6.72H32.4l2.28-6.72Zm4.968 13.224h3.192l-6.36-17.112h-3.264L27 47.44h3.216l1.296-3.84h6.792l1.344 3.84Zm6.336-15.288c1.392 0 2.088-.6 2.088-2.088 0-1.536-.72-2.064-2.088-2.064s-2.088.528-2.088 2.064c0 1.56.576 2.088 2.088 2.088Zm1.56 15.288v-13.8h-3.192v13.8h3.192Z",
        fill: "#FF8E21"
      }
    )
  );
};
export {
  FileIllustratorLarge
};
